import styled from 'styled-components';

export const ContactWrapper = styled.div`
  padding: 20px;
`;

export const ContactBtnContainer = styled(ContactWrapper)`
  display: flex;
  justify-content: flex-end;
  padding: 0px;
`;